var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        fill: "#000000",
        width: "20px",
        height: "20px",
        viewBox: "0 0 35 35",
        "data-name": "Layer 2",
        id: "f7b9d31b-3db4-48db-9630-5b4624996f58",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M29.467,34.749H5.53A5.288,5.288,0,0,1,.25,29.467V5.532A5.286,5.286,0,0,1,5.53.252H29.467a5.286,5.286,0,0,1,5.28,5.28V29.467A5.288,5.288,0,0,1,29.467,34.749ZM5.53,2.752a2.783,2.783,0,0,0-2.78,2.78V29.467a2.784,2.784,0,0,0,2.78,2.782H29.467a2.784,2.784,0,0,0,2.78-2.782V5.532a2.783,2.783,0,0,0-2.78-2.78Z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M11.86,17.226a4.468,4.468,0,1,1,4.468-4.468A4.473,4.473,0,0,1,11.86,17.226Zm0-6.435a1.968,1.968,0,1,0,1.968,1.967A1.97,1.97,0,0,0,11.86,10.791Z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M2.664,31.92a1.25,1.25,0,0,1-.929-2.085l5.876-6.547a3.288,3.288,0,0,1,4.553-.341l2.525,2.084a.77.77,0,0,0,.6.178.794.794,0,0,0,.543-.3l6.644-8.584a3.277,3.277,0,0,1,2.6-1.279h.012A3.282,3.282,0,0,1,27.673,16.3l6.372,8.107a1.25,1.25,0,0,1-1.966,1.545l-6.372-8.107a.785.785,0,0,0-.627-.3.864.864,0,0,0-.631.309L17.8,26.434a3.3,3.3,0,0,1-4.707.525l-2.525-2.084a.794.794,0,0,0-1.1.083L3.6,31.5A1.245,1.245,0,0,1,2.664,31.92Z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }